"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var react_router_dom_1 = require("react-router-dom");
var launchdarkly_react_client_sdk_1 = require("launchdarkly-react-client-sdk");
var prop_types_1 = (0, tslib_1.__importDefault)(require("prop-types"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var ListItem_1 = (0, tslib_1.__importDefault)(require("@material-ui/core/ListItem"));
var ListItemIcon_1 = (0, tslib_1.__importDefault)(require("@material-ui/core/ListItemIcon"));
var ListItemText_1 = (0, tslib_1.__importDefault)(require("@material-ui/core/ListItemText"));
var ListSubheader_1 = (0, tslib_1.__importDefault)(require("@material-ui/core/ListSubheader"));
var Divider_1 = (0, tslib_1.__importDefault)(require("@material-ui/core/Divider"));
var fos_ui_1 = require("@ntet/fos-ui");
var announcekit_react_1 = (0, tslib_1.__importDefault)(require("announcekit-react"));
var style_1 = require("./style");
var ClientList_1 = (0, tslib_1.__importDefault)(require("./ClientList"));
var useAuth_1 = require("../../auth/useAuth");
var hooks_1 = require("../../hooks");
var UserFunctionsContext_1 = require("../../auth/UserFunctionsContext");
var utils_1 = require("../../utils");
var routes_1 = require("../../auth/routes");
var PariluxDataContext_1 = require("../../auth/PariluxDataContext");
var NavActions = function (_a) {
    var openGlobalSettingsPanel = _a.openGlobalSettingsPanel, settingsOpen = _a.settingsOpen;
    var _b = (0, launchdarkly_react_client_sdk_1.useFlags)(), _c = _b.contactAndStatusPage, contactAndStatusPage = _c === void 0 ? false : _c, _d = _b.enableQuickAddDropdown, enableQuickAddDropdown = _d === void 0 ? false : _d;
    var _e = (0, react_1.useState)(null), profileAnchorEl = _e[0], setProfileAnchorEl = _e[1];
    var _f = (0, react_1.useState)(null), addAnchorEl = _f[0], setAddAnchorEl = _f[1];
    var _g = (0, react_1.useState)(null), redirectUri = _g[0], setRedirectUri = _g[1];
    var _h = (0, react_1.useState)(false), shouldInitializeAnnounceKit = _h[0], setShouldInitializeAnnounceKit = _h[1];
    var _j = (0, react_1.useState)({}), announceKitData = _j[0], setAnnounceKitData = _j[1];
    var ref = (0, react_1.useRef)();
    var _k = (0, react_1.useState)(0), unreadAnnouncements = _k[0], setUnreadAnnouncements = _k[1];
    var history = (0, react_router_dom_1.useHistory)();
    var pathname = (0, react_router_dom_1.useLocation)().pathname;
    var _l = (0, useAuth_1.useAuth)(), userId = _l.userId, email = _l.email, user = _l.user, setUserItemID = _l.setUserItemID;
    var _m = (0, PariluxDataContext_1.useUserPlxData)(), userItemID = _m.userItemID, dbName = _m.dbName, dbAlias = _m.dbAlias;
    var allItemTypes = (0, hooks_1.useAllItemTypes)(true).data;
    // gets user functions
    var _o = (0, UserFunctionsContext_1.useUserFunctionsContext)(), addEditDossierEvents = _o.addEditDossierEvents, addEditDossierFiles = _o.addEditDossierFiles;
    var isResearch = (0, react_1.useMemo)(function () { return /^\/research\/.*$/.test(pathname); }, [pathname]);
    (0, react_1.useEffect)(function () {
        (function () { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
            var announceKitObject, unreadMessages;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!userItemID) return [3 /*break*/, 2];
                        announceKitObject = {
                            user: {
                                id: email,
                                fmid: "".concat(dbName, "_").concat(userItemID),
                                email: email,
                                name: "".concat(user.given_name, " ").concat(user.family_name),
                            },
                            data: {
                                database: dbAlias,
                                FOSOnly: email.includes('ntrs'),
                                WebLastLogin: new Date().toLocaleDateString('en-US', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                }),
                            },
                        };
                        setAnnounceKitData(announceKitObject);
                        setShouldInitializeAnnounceKit(true);
                        if (!ref.current) return [3 /*break*/, 2];
                        return [4 /*yield*/, ref.current.unread()];
                    case 1:
                        unreadMessages = _a.sent();
                        setUnreadAnnouncements(unreadMessages);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); })();
    }, [userItemID, shouldInitializeAnnounceKit]);
    (0, react_1.useEffect)(function () {
        if (pathname === redirectUri) {
            setProfileAnchorEl(null);
            setRedirectUri(null);
        }
    }, [redirectUri, pathname]);
    (0, react_1.useEffect)(function () {
        if (settingsOpen) {
            setProfileAnchorEl(null);
        }
    }, [settingsOpen]);
    var quickAddItems = (0, react_1.useMemo)(function () {
        if (!allItemTypes)
            return [];
        var exclude = [9, 12, 26, 53, 54, 60];
        var include = [34];
        var data = allItemTypes
            .filter(function (item) {
            if (include.includes(item.ID))
                return true;
            if (exclude.includes(item.ID))
                return false;
            return item.BaseID === 8;
        })
            .sort((0, utils_1.compareObjectByKey)('Name'));
        return data;
    }, [allItemTypes]);
    var displayAddPanel = (0, react_1.useCallback)(function (panel) {
        window.MFE.dispatchCommand('openDrawer', panel);
        setAddAnchorEl(null);
    }, []);
    var addMenu = (0, react_1.useMemo)(function () { return (react_1.default.createElement(style_1.StyledMenu, { id: "add-menu", anchorEl: addAnchorEl, open: Boolean(addAnchorEl), "aria-label": "quick add", onClose: function () { return setAddAnchorEl(null); } },
        react_1.default.createElement(ListSubheader_1.default, null, "Research"),
        !addEditDossierEvents ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(fos_ui_1.ToolTip, { infoText: "You don't have permission to take this action.", placement: "bottom", margin: "-40px 0px 0px 40px" },
                react_1.default.createElement(StyledDiv, null,
                    react_1.default.createElement(DisabledListItem, { button: true, disabled: true, onClick: function () { return displayAddPanel('Event'); } },
                        react_1.default.createElement(ListItemIcon_1.default, null,
                            react_1.default.createElement("i", { className: "dds-icons icon" }, "add_circle")),
                        react_1.default.createElement(ListItemText_1.default, { primary: "Event" })))))) : (react_1.default.createElement(ListItem_1.default, { button: true, onClick: function () { return displayAddPanel('Event'); } },
            react_1.default.createElement(ListItemIcon_1.default, null,
                react_1.default.createElement("i", { className: "dds-icons icon" }, "add_circle")),
            react_1.default.createElement(ListItemText_1.default, { primary: "Event" }))),
        !addEditDossierFiles ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(fos_ui_1.ToolTip, { infoText: "You don't have permission to take this action.", placement: "bottom", margin: "-40px 0px 0px 40px" },
                react_1.default.createElement(StyledDiv, null,
                    react_1.default.createElement(DisabledListItem, { button: true, onClick: function () { return displayAddPanel('File'); }, disabled: true },
                        react_1.default.createElement(ListItemIcon_1.default, null,
                            react_1.default.createElement("i", { className: "dds-icons icon" }, "add_circle")),
                        react_1.default.createElement(ListItemText_1.default, { primary: "File" })))),
            react_1.default.createElement("li", null))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ListItem_1.default, { button: true, onClick: function () { return displayAddPanel('File'); } },
                react_1.default.createElement(ListItemIcon_1.default, null,
                    react_1.default.createElement("i", { className: "dds-icons icon" }, "add_circle")),
                react_1.default.createElement(ListItemText_1.default, { primary: "File" })),
            react_1.default.createElement("li", null))),
        quickAddItems.map(function (item) { return (react_1.default.createElement(ListItem_1.default, { button: true, key: item.ID, onClick: function () { return displayAddPanel(item.Name); } },
            react_1.default.createElement(ListItemIcon_1.default, null,
                react_1.default.createElement("i", { className: "dds-icons icon" }, "add_circle")),
            react_1.default.createElement(ListItemText_1.default, { primary: item.Name }))); }),
        react_1.default.createElement("li", null),
        react_1.default.createElement(ListItem_1.default, { button: true, onClick: function () { return displayAddPanel('Person'); } },
            react_1.default.createElement(ListItemIcon_1.default, null,
                react_1.default.createElement("i", { className: "dds-icons icon" }, "add_circle")),
            react_1.default.createElement(ListItemText_1.default, { primary: "Person" })))); }, [addAnchorEl, displayAddPanel, quickAddItems]);
    var profileMenu = (0, react_1.useMemo)(function () { return (react_1.default.createElement(style_1.StyledMenu, { id: "profile-menu", anchorEl: profileAnchorEl, open: Boolean(profileAnchorEl), "aria-label": "profile settings", onClose: function () { return setProfileAnchorEl(null); } },
        react_1.default.createElement(ListItem_1.default, null,
            react_1.default.createElement(ListItemText_1.default, { primary: "Hello, ".concat(userId) })),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(ListItem_1.default, { button: true, onClick: function () { return openGlobalSettingsPanel(); } },
            react_1.default.createElement(ListItemText_1.default, { primary: "Settings" })),
        react_1.default.createElement(ListItem_1.default, { button: true, onClick: function () { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
                return (0, tslib_1.__generator)(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!ref.current) return [3 /*break*/, 2];
                            return [4 /*yield*/, ref.current.open()];
                        case 1:
                            _a.sent();
                            setProfileAnchorEl(null);
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); } },
            react_1.default.createElement(ListItemText_1.default, { primary: "Announcements" }),
            !!unreadAnnouncements && (react_1.default.createElement(style_1.StyledSpan, null, unreadAnnouncements))),
        react_1.default.createElement(Divider_1.default, null),
        react_1.default.createElement(ClientList_1.default, null),
        react_1.default.createElement(ListItem_1.default, { button: true, onClick: function () { return history.push(routes_1.routes.logout); } },
            react_1.default.createElement(ListItemText_1.default, { primary: "Log Out" })))); }, [
        profileAnchorEl,
        contactAndStatusPage,
        history,
        openGlobalSettingsPanel,
        userId,
    ]);
    /* TODO: simplify/remove this function when the 'enableQuickAddDropdown'
     * flag is archived in LaunchDarkly. */
    function handleQuickAddClick(e) {
        if (enableQuickAddDropdown) {
            setAddAnchorEl(e.currentTarget);
        }
    }
    return !redirectUri ? (react_1.default.createElement(StyledActionsList, null,
        react_1.default.createElement("li", null,
            react_1.default.createElement(style_1.StyledButton, { disabled: true },
                react_1.default.createElement("i", { className: "dds-icons icon" }, "search"))),
        react_1.default.createElement("li", null,
            react_1.default.createElement(style_1.StyledButton, { disabled: !enableQuickAddDropdown || !isResearch, className: [Boolean(addAnchorEl) && 'active']
                    .filter(Boolean)
                    .join(' '), onClick: handleQuickAddClick },
                react_1.default.createElement("i", { className: "dds-icons icon" }, "add_circle")),
            addMenu),
        react_1.default.createElement("li", null,
            react_1.default.createElement(style_1.StyledButton, { disabled: true },
                react_1.default.createElement("i", { className: "dds-icons icon" }, "message_reply_text"))),
        react_1.default.createElement("li", null,
            react_1.default.createElement(style_1.StyledButton, { onClick: function (e) {
                    setProfileAnchorEl(e.currentTarget);
                }, className: [Boolean(profileAnchorEl) && 'active']
                    .filter(Boolean)
                    .join(' ') },
                react_1.default.createElement("i", { className: "dds-icons icon" }, "person_circle"),
                profileAnchorEl && react_1.default.createElement("i", { className: "dds-icons icon" }, "menu_up"),
                !profileAnchorEl && !!unreadAnnouncements && (react_1.default.createElement(style_1.StyledSpanProfile, null, unreadAnnouncements))),
            profileMenu),
        shouldInitializeAnnounceKit && (react_1.default.createElement(announcekit_react_1.default, { widgetStyle: { display: 'none' }, widget: "https://announcekit.co/widgets/v2/3BN3LG", onWidgetUnread: function (widget) {
                if (!widget.unread) {
                    setUnreadAnnouncements(0);
                }
            }, data: announceKitData.data, user: announceKitData.user, ref: ref })))) : (react_1.default.createElement(react_router_dom_1.Redirect, { to: redirectUri }));
};
NavActions.propTypes = {
    openGlobalSettingsPanel: prop_types_1.default.func.isRequired,
    settingsOpen: prop_types_1.default.bool.isRequired,
};
var StyledActionsList = (0, styled_components_1.default)(style_1.StyledList)(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  > li:last-of-type {\n    width: 56px;\n  }\n\n  @media only screen and (min-width: ", ") {\n    margin-left: 2.4rem;\n    width: auto;\n\n    li + li {\n      margin-left: 1.6rem;\n    }\n  }\n"], ["\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  > li:last-of-type {\n    width: 56px;\n  }\n\n  @media only screen and (min-width: ", ") {\n    margin-left: 2.4rem;\n    width: auto;\n\n    li + li {\n      margin-left: 1.6rem;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.desktop;
});
var DisabledListItem = (0, styled_components_1.default)(ListItem_1.default)(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  &&.Mui-disabled {\n    cursor: not-allowed;\n    opacity: 1;\n  }\n"], ["\n  &&.Mui-disabled {\n    cursor: not-allowed;\n    opacity: 1;\n  }\n"])));
var StyledDiv = styled_components_1.default.div(templateObject_3 || (templateObject_3 = (0, tslib_1.__makeTemplateObject)(["\n  cursor: not-allowed;\n  opacity: 0.4;\n"], ["\n  cursor: not-allowed;\n  opacity: 0.4;\n"])));
exports.default = NavActions;
var templateObject_1, templateObject_2, templateObject_3;
